export default __webpack_public_path__ + "static/media/negotiation.05b847e3.svg";